import { gamesImagesData } from "../../utils/data/homePage.data";
import {
  EXCHANGE_EVENT_TYPES,
  fetchInplayEvent,
  fetchNotifications,
  getInplayEvents,
  LOGIN_ROUTE,
  RootState,
  setCompetition,
  setEventType,
  setIsLoginModalOpen,
  SPORTS_MAP,
  useAppDispatch,
  useAppSelector,
  getSectionGameImage,
  getSectionGameKey,
  getSectionGameLabel,
  getSectionGameNavigationPath,
  isProviderCategorySectionEntry,
  isSectionLottieFile,
  SectionGame,
  useHomeSectionGames,
  HomeSectionGamesProvider,
  CasinoTagsEnum,
  setAlertMsg,
  HOME_ROUTE,
  INT_CASINO_ROUTE,
} from "@hypexone/uicore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GCImage from "../../assets/images/Casino_svg_img/GC_Logo.svg";
import LICImage from "../../assets/images/Casino_svg_img/LIC.svg";
import Lottie from "lottie-react";
import { commonPaddingBottomForMobile } from "../../utils/constants/common.constants";
import Popup from "../components/home/Popup";
import MobileFooter from "../components/mobile-footer/MobileFooter";
import NewsAndPromotions from "../components/shared/NewsAndPromotions";
import Header from "../components/header/Header";
import LiveGif from "../../assets/images/Casino_svg_img/Live.svg";
import ProvidersSection from "./ProvidersSection";
import { isDesktop, isIOS, isMobile } from "react-device-detect";
import { appNavigationConstants } from "../../utils/constants/header.constants";
import { connect } from "react-redux";
import {
  BannerObjData,
  BannerResData,
} from "@hypexone/uicore/lib/cjs/src/models/Banners";
import HomeGames from "./WithdrawAmount/HomeGames";
import { accountClient, SVLS_API_CLIENT } from "../../App.utils";
import { BRAND_DOMAIN, domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/brandConfig";
import { AxiosResponse } from "axios";
import ClientSecurityMessageModal from "../components/header/ClientSecurityMessageModal";
import YuviGames from "../components/YuviGames/YuviGames";
import { trackApkDownload } from "../../utils/trackApkDownload";
import OldApkbanner from "../../assets/images/old_users_apk.jpeg";
import "./apkCopyLink.css";
import { isApkCopyLinkDomain } from "../../constants/apkCopyLink";
import {
  useDownloadAppBannerClick,
  visibleBanners,
} from "../../utils/apkBanner";

export const isAndroidWebView = (): boolean => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const hasWvToken = /; wv\)/i.test(ua);
    const isChromeBrowser = /Chrome\/[\d.]+/i.test(ua) && !/EdgA\//i.test(ua);
    const looksLikeStandaloneChrome =
      isChromeBrowser && /Version\/[\d.]+/i.test(ua) === false && !hasWvToken;
    return (
      isAndroid &&
      (hasWvToken || (!looksLikeStandaloneChrome && /Version\/[\d.]+/i.test(ua)))
    );
  };

const FANTASY_SPORTS_SECTION_CODE = "fantasy_sports";
const CASINO_LOBBY_SECTION_CODE = "casino_lobby";
const HOME_SECTION_CODES = [
  CasinoTagsEnum.NEW_LAUNCH + "_laser",
  CasinoTagsEnum.TRENDING,
  CasinoTagsEnum.RECOMMENDED_GAMES,
  CasinoTagsEnum.LIVE_CASINO_GAMES,
  CasinoTagsEnum.SLOTS,
  CASINO_LOBBY_SECTION_CODE,
  FANTASY_SPORTS_SECTION_CODE,
];

const HomeFantasySports = ({
  onGameClick,
}: {
  onGameClick: (game: SectionGame) => void;
}) => {
  const { games: fantasySportsGames, lottieAnimations } = useHomeSectionGames(
    SVLS_API_CLIENT,
    FANTASY_SPORTS_SECTION_CODE
  );

  if (fantasySportsGames.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full gap-[2px]">
      {fantasySportsGames.map((game) => {
        const imageUrl = getSectionGameImage(game);
        const gameKey = getSectionGameKey(game);
        const lottieData = lottieAnimations[gameKey];

        return (
          <div
            key={gameKey}
            className="cursor-pointer"
            style={{ width: `${100 / fantasySportsGames.length}%` }}
            onClick={() => onGameClick(game)}
          >
            {isSectionLottieFile(imageUrl) && lottieData ? (
              <Lottie animationData={lottieData} loop={true} />
            ) : (
              imageUrl && (
                <img
                  src={imageUrl}
                  alt={getSectionGameLabel(game)}
                  className="w-full"
                />
              )
            )}
          </div>
        );
      })}
    </div>
  );
};


const HomePage = ({ loggedIn, balance, exposure }) => {
  const navigate = useNavigate();
  const handleDownloadAppBanner = useDownloadAppBannerClick();
  const dispatch = useAppDispatch();
  const { langData } = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  const apkUrl = getEnvVariable(domain, "apk_url") || domainConfig?.apkUrl;
  const allowedTrendingNames = [
    "coin flip",
    "fortune wheel",
    "twistx",
    "lucky 5",
    "rock paper scissors",
    "valentine",
    "bolly kiss",
    "limbo",
    "plinko",
    "crash x",
    "diamonds",
    "pushpa rani",
    "dice",
  ];
  // const { loggedIn } = useAppSelector((state) => state.auth);
  const [bannersData, setBannersData] = useState<BannerObjData[]>([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const handleSectionGameClick = (game: SectionGame) => {
    const path = getSectionGameNavigationPath(
      game,
      INT_CASINO_ROUTE,
      "subProvider"
    );
    if (!path) return;

    if (isProviderCategorySectionEntry(game)) {
      navigate(path);
      return;
    }

    if (!loggedIn) {
      navigate(LOGIN_ROUTE, { replace: true });
      return;
    }

    const loggedInUserStatus = JSON.parse(
      window.atob(sessionStorage.getItem("jwt_token").split(".")[1])
    ).status;
    if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
      navigate(HOME_ROUTE);
      return;
    }

    navigate(path, { state: { gameName: game.gameName } });
  };

  const trending =
    useAppSelector((state) => state?.common?.trendingGames) || [];

  // Before and After Login Banners
  const [popupBanner, setPopupBanner] = useState<BannerObjData>();
  const [downloadApkBanner, setDownloadApkBanner] = useState<BannerObjData>();
  const [popupMobileBanner, setPopupMobileBanner] = useState<BannerObjData>();
  const [downloadApkMobileBanner, setDownloadApkMobileBanner] =
    useState<BannerObjData>();
  const [showApkPopup, setShowApkPopup] = useState(false);
  const [isApkAvailable, setIsApkAvailable] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false);

  const fetchBanners = async () => {
    const response = await accountClient.getBannersByCategory(
      BRAND_DOMAIN,
      "diamondgifs"
    );
    setBannersData(visibleBanners(response?.banners, isAndroidWebView()));
  };
  useEffect(() => {
    fetchBanners();
  }, []);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchNotifications());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  function handleNavigation(url: string) {
    // Check if the user is trying to navigate to /sportsbook and if they are logged in
    if (url === "/sportsbook" && !loggedIn) {
      setShowLoginPopup(true); // Show the popup if not logged in
      return; // Stop the navigation
    }
    navigate(url); // Navigate if allowed
  }
  // const username = sessionStorage.getItem("username");
  // const errorHandler = (error: any) => {
  //   console.log(error.response.data.message);
  // };
  // const urlsMap = getUrlMap();
  // const accountClient = new AccountClient(urlsMap, jwtToken, errorHandler);

  // const fetchData = async () => {
  //   await accountClient
  //     .getProfile(username)
  //     .then((response: { data: any }) => {
  //       console.log(response.data);
  //     })
  //     .catch((error: any) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  const { events: catalogEvents, selectedEventType } = useAppSelector(
    (state) => state.catalog
  );
  const { allowedConfig } = useAppSelector((state) => state.common);

  const inplayEvents = getInplayEvents(catalogEvents, allowedConfig);

  // Create a combined array of all sports with their event counts
  const allSportsWithCounts = EXCHANGE_EVENT_TYPES.map((sport) => {
    const inplayEvent = inplayEvents.find(
      (event) => event?.sportName?.toLowerCase() === sport?.name?.toLowerCase()
    );
    return {
      ...sport,
      eventCount: inplayEvent ? inplayEvent.events.length : 0,
      sportName: sport.name,
    };
  });

  useEffect(() => {
    dispatch(fetchInplayEvent());
  }, []);

  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));

    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
    const navItem = appNavigationConstants.find((item) => item.title === title);
    if (navItem) {
      navigate(navItem.navigationUrl);
    } else {
    }
  };

  const getPopupBanners = async () => {
    const bannersRes: AxiosResponse<BannerResData> = await SVLS_API_CLIENT.get(
      `/account/v2/books/${BRAND_DOMAIN}/banners`,
      {
        params: {
          category: "popupbanner,downloadApkBanner",
          status: "active",
        },
      }
    );

    if (bannersRes.data.banners && bannersRes.data.banners.length >= 2) {
      setDownloadApkBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "downloadApkBanner" && b.deviceType == "desktop"
        )[0]
      );
      setDownloadApkMobileBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "downloadApkBanner" && b.deviceType == "mobile"
        )[0]
      );

      setPopupBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "popupbanner" && b.deviceType == "desktop"
        )[0]
      );
      setPopupMobileBanner(
        visibleBanners(bannersRes.data.banners, isAndroidWebView()).filter(
          (b) => b.category == "popupbanner" && b.deviceType == "mobile"
        )[0]
      );
    }
  };

  useEffect(() => {
    if (!sessionStorage.getItem("popup_shown")) {
      getPopupBanners();
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem("popup_shown", "true");
    setShowPopup(false);
  };

  const handleBannerRedirect = (redirectionUrl?: string) => {
    const redirectUrl = redirectionUrl?.trim();
    if (!redirectUrl || redirectUrl.toLowerCase() === "nourl") {
      return;
    }

    if (redirectUrl.startsWith("http")) {
      window.location.href = redirectUrl;
      return;
    }

    navigate(redirectUrl.startsWith("/") ? redirectUrl : `/${redirectUrl}`);
  };

  const handlePopupBannerClick = () => {
    const banner = isMobile ? popupMobileBanner : popupBanner;
    closePopup();
    if (handleDownloadAppBanner(banner, "popup_banner")) return;
    handleBannerRedirect(banner?.redirectionUrl);
  };

  useEffect(() => {
    if (loggedIn && !sessionStorage.getItem("popup_shown")) {
      setShowPopup(true);
    }
  }, [loggedIn]);

  useEffect(() => {
    if (!sessionStorage.getItem("apk_popup_shown")) {
      setShowApkPopup(true);
    }
  }, []);

  const closeApkPopup = () => {
    sessionStorage.setItem("apk_popup_shown", "true");
    setShowApkPopup(false);
  };

  useEffect(() => {
    setIsApkAvailable(!!apkUrl);
  }, [apkUrl]);

  // Domains where Android WebView users should copy APK link instead of direct download
  const shouldCopyApkLink = isApkCopyLinkDomain();

  

  const resolveApkHref = () => {
    if (!apkUrl) return null;
    return apkUrl.startsWith("http") ? apkUrl : `https://${apkUrl}`;
  };

  const copyApkLink = async () => {
    const url = resolveApkHref();
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt("Copy this APK link:", url);
    }
    dispatch(
      setAlertMsg({
        type: "success",
        message: "Link copied. Open browser and paste to download the new APK.",
      })
    );
  };

  const downloadApp = async () => {
    if (!apkUrl) return;
    const url = resolveApkHref();
    if (!url) return;
    if (shouldCopyApkLink && isAndroidWebView()) {
      await copyApkLink();
      return;
    }
    trackApkDownload("popup");
    const link = document.createElement("a");
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex bg-[#dee2e6] flex-col h-full w-full overflow-auto gap-[1px] mb-64 router-ctn">
      <div>
        <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      </div>
      <div
        className={`flex flex-col flex-1 px-[1px] md:px-[55px] overflow-auto hide-scrollbar bg-white pb-32 ${commonPaddingBottomForMobile}`}
      >
        <div className="flex flex-col gap-[2px]">
          <div className="hidden md:block">
            <NewsAndPromotions />
          </div>
          <HomeSectionGamesProvider
            apiClient={SVLS_API_CLIENT}
            sectionCodes={HOME_SECTION_CODES}
          >
          <HomeFantasySports onGameClick={handleSectionGameClick} />

          <div className="grid grid-cols-4 md:grid-cols-6 gap-0.5 w-full">
            {gamesImagesData.map(
              ({ imageSrc, url, alt, customClassName, title }, index) => {
                let computedClass = "";

                if (index === 0) {
                  // Full width on both mobile and desktop
                  computedClass = "col-span-4 md:col-span-6";
                } else if (index === 1) {
                  isDesktop
                    ? (computedClass = "col-span-2 md:col-span-3")
                    : (computedClass = "col-span-4 md:col-span-6");
                } else if (index === 2) {
                  isDesktop
                    ? (computedClass = "col-span-2 md:col-span-3")
                    : (computedClass = "col-span-4 md:col-span-6");
                } else {
                  // Two items per row
                  computedClass = "col-span-2 md:col-span-3";
                }

                return (
                  <div
                    key={index}
                    className={`w-full cursor-pointer relative ${computedClass}`}
                  >
                    <img
                      onClick={() => handleNavigation(url)}
                      src={imageSrc}
                      alt={alt}
                      className="w-full h-auto object-cover"
                    />

                    {index === 1 && (
                      <div className="absolute right-0 top-0 z-10 h-full bg-gradient-to-b from-black/95 to-black/30 w-[120px] md:w-[160px] text-white overflow-auto p-2">
                        <div className="w-16 h-5 overflow-hidden">
                          <img
                            className="object-cover h-4"
                            src={LiveGif}
                            alt="LiveGif"
                          />
                        </div>
                        <div className="flex flex-col gap-1">
                          {allSportsWithCounts.map((sport) => (
                            <div
                              key={sport.id}
                              className="text-[11px] leading-[10px] md:text-xs flex justify-between md:font-bold"
                              onClick={() =>
                                handleNavLinkClick(sport.sportName)
                              }
                            >
                              <div>{sport.sportName}</div>
                              <div className="bg-white text-black rounded py-[2px] px-1 font-normal">
                                {sport.eventCount}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {title && (
                      <div className="w-full bg-black text-center uppercase font-bold text-white p-1 px-2 text-xs md:text-sm">
                        {title}
                      </div>
                    )}
                  </div>
                );
              }
            )}

            {showLoginPopup && (
              <Popup
                message="You must be logged in to access the Sportsbook."
                onClose={() => setShowLoginPopup(false)}
              />
            )}
          </div>
          <div className="grid grid-cols-4 sm:grid-cols-8 gap-0.5">
            {bannersData?.map((banner) =>
              banner.deviceType === "desktop" ? (
                <div className="hidden md:block">
                  <img
                    key={banner.id}
                    src={banner.publicUrl}
                    alt={banner.title}
                    className="w-[100%] cursor-pointer"
                    onClick={() => {
                      if (handleDownloadAppBanner(banner, "banner")) return;
                      handleBannerRedirect(banner.redirectionUrl);
                    }}
                  />
                  {/* <div className="flex items-center justify-center w-full h-[33px] bg-black pl-2 text-center uppercase font-bold text-white text-xs md:text-sm md:py-2 break-words">
                    {banner.title}
                  </div> */}
                </div>
              ) : (
                <div className="md:hidden">
                  <img
                    key={banner.id}
                    src={banner.publicUrl}
                    alt={banner.title}
                    className="w-[100%] h-[70px] sm:h-[113px] cursor-pointer"
                    onClick={() => {
                      if (handleDownloadAppBanner(banner, "banner")) return;
                      handleBannerRedirect(banner.redirectionUrl);
                    }}
                  />
                  {/* <div className="flex items-center justify-center w-full h-[32px] bg-black pl-2 text-center uppercase font-bold text-white text-xs md:text-sm md:py-2 break-words">
                    {banner.title}
                  </div> */}
                </div>
              )
            )}
          </div>
          <HomeGames
            isLoggedIn={loggedIn}
            showPopUp={() => setShowLoginPopup(true)}
          />

        <div>
          <div
            className="w-full py-[6px] px-[5px] text-[13px] md:text-[16px] uppercase my-[2px] text-white"
            style={{
              background: "linear-gradient(-180deg, #F72424 0%, #BB1C00 100%)",
            }}
          >
            {langData?.["top_providers"]}
          </div>

          <div>
            <ProvidersSection />
          </div>
        </div>
        </HomeSectionGamesProvider>
        </div>

        <div className=" flex-col flex items-center sm:px-0  md:px-20 gap-3">
          <div className="flex flex-col md:flex-row w-full max-w-[670px] mx-auto rounded-lg border border-black2 overflow-hidden md:min-h-[140px]">
            <div className="flex justify-center items-center w-full md:w-auto md:border-r border-r-black2 px-2 py-1 md:py-0">
              <img
                src={GCImage}
                alt="gc-image"
                className="w-[120px] h-auto md:w-[120px] object-contain"
              />
            </div>
            <div className="flex flex-col md:flex-row justify-center md:justify-start items-center gap-1 sm:gap-3 md:p-3 p-1 md:px-4 w-full">
              <img
                src={LICImage}
                alt="lic-image"
                className="max-w-[100px] w-full h-auto object-contain"
              />
              <span className="text-[11px] text-center md:text-left leading-snug">
                Laser is the trading name of Sports Target B.V., a company
                incorporated and regulated in Curaçao under company number
                148053 with its registered office at Fransche Bloemweg 4,
                Willemstad, Curaçao.
              </span>
            </div>
          </div>

          {isDesktop && (
            <div className="hidden w-full md:flex flex-col gap-2 items-center md:px-12 lg:px-20">
              <div className="text-center text-xs text-gray5 px-4">
                Our website works best in the newest and last prior version of
                these browsers: Google Chrome. Firefox
              </div>
              <div className="h-[1px] w-[76%] bg-black2" />
            </div>
          )}
          {isDesktop && (
            <div className="grid grid-cols-10 md:flex justify-center w-full text-[13px] md:text-[11px] text-black3 md:text-black underline gap-3 text-center">
              <span className="col-span-4 cursor-pointer text-right">
                Privacy Policy
              </span>
              <span className="col-span-4 cursor-pointer text-right">
                Terms And Conditions
              </span>
              <span className="col-span-6 cursor-pointer text-left">
                Rules And Regulations
              </span>

              <span className="col-span-4 cursor-pointer">About Us</span>
              <span className="col-span-4 cursor-pointer">
                Responsible Gaming
              </span>
            </div>
          )}
          {/* <div className="self-center">
            <img
              src={MobileAppQRImage}
              alt="mobile-app-qr"
              className="w-[150px]"
            />
          </div> */}
        </div>
      </div>

      {isMobile || isIOS ? <YuviGames /> : null}

      <div className="md:hidden">
        <MobileFooter />
      </div>

      <div>
        {showApkPopup &&
        isApkAvailable &&
        (shouldCopyApkLink ||
          (downloadApkBanner?.publicUrl &&
            downloadApkMobileBanner?.publicUrl)) ? (
          !isAndroidWebView() && (
          <ClientSecurityMessageModal
            isOpen={showApkPopup}
            onClose={closeApkPopup}
            isContentWidth
            hideCloseIcon
            modalBg="bg-transparent"
            showCloseIconInsideContent
            closeOutside
          >
            <div
              className={`popup-banner-wrapper${
                shouldCopyApkLink ? " popup-banner-wrapper--old-apk" : ""
              }`}
            >
              <a
                href={resolveApkHref() || "#"}
                onClick={(e) => {
                  e.preventDefault();
                  downloadApp();
                }}
              >
                <img
                  src={
                    shouldCopyApkLink
                      ? OldApkbanner
                      : isMobile
                        ? downloadApkMobileBanner?.publicUrl
                        : downloadApkBanner?.publicUrl
                  }
                  alt="Download APK"
                  className={isMobile ? "" : "max-h-[66vh]"}
                />
              </a>
              {shouldCopyApkLink && apkUrl ? (
                <div className="old-apk-link-bar">
                  <p className="old-apk-link-bar__label">Official APK link</p>
                  <div className="old-apk-link-bar__row">
                    <p
                      className="old-apk-link-bar__url"
                      title={resolveApkHref() || apkUrl}
                    >
                      {apkUrl}
                    </p>
                    <button
                      type="button"
                      className="old-apk-link-bar__copy"
                      onClick={copyApkLink}
                    >
                      Copy
                    </button>
                  </div>
                  <p className="old-apk-link-bar__hint">
                    Browser mein paste karke new APK download kardo
                  </p>
                </div>
              ) : null}
            </div>
          </ClientSecurityMessageModal>
          )
        ) : (
          showPopup &&
          popupBanner &&
          popupMobileBanner && (
            <ClientSecurityMessageModal
              modalBg="bg-transparent"
              isOpen={showPopup}
              onClose={closePopup}
              hideCloseIcon
              isContentWidth
              showCloseIconInsideContent
              closeOutside
            >
              <img
                src={
                  isMobile
                    ? popupMobileBanner?.publicUrl
                    : popupBanner?.publicUrl
                }
                onClick={handlePopupBannerClick}
                className={isMobile ? "" : "max-h-[66vh]"}
              />
            </ClientSecurityMessageModal>
          )
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
